export const getIsAValidMaxFileSize = (file = {}, maxFileSize = 18000000) => {
  const isAValidFile = file instanceof File;

  if (!isAValidFile) {
    return false;
  }
  return Number(file.size) <= maxFileSize;
};
